import React, { useState, useEffect, useCallback, useRef } from 'react';

const HeroCarousel = ({ images, intervalMs = 5000 }) => {
  const [index, setIndex] = useState(0);
  const touchStartX = useRef(null);

  const goTo = useCallback((i) => {
    setIndex((i + images.length) % images.length);
  }, [images.length]);

  const next = useCallback(() => goTo(index + 1), [index, goTo]);
  const prev = useCallback(() => goTo(index - 1), [index, goTo]);

  // Auto-advance every `intervalMs`; restarts whenever the slide changes (auto or manual)
  useEffect(() => {
    if (images.length <= 1) return undefined;
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, intervalMs);
    return () => clearInterval(timer);
  }, [images.length, intervalMs, index]);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const deltaX = e.changedTouches[0].clientX - touchStartX.current;
    const SWIPE_THRESHOLD = 50;
    if (deltaX > SWIPE_THRESHOLD) {
      prev();
    } else if (deltaX < -SWIPE_THRESHOLD) {
      next();
    }
    touchStartX.current = null;
  };

  if (!images || images.length === 0) return null;

  return (
    <div
      className="hero-carousel"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <div
        className="hero-carousel-track"
        style={{ transform: `translateX(-${index * 100}%)` }}
      >
        {images.map((img, i) => (
          <div className="hero-carousel-slide" key={i}>
            <img src={img.src} alt={img.alt} />
          </div>
        ))}
      </div>

      {images.length > 1 && (
        <>
          <button
            type="button"
            className="hero-carousel-arrow hero-carousel-prev"
            onClick={prev}
            aria-label="Image précédente"
          >
            <i className="fas fa-chevron-left"></i>
          </button>
          <button
            type="button"
            className="hero-carousel-arrow hero-carousel-next"
            onClick={next}
            aria-label="Image suivante"
          >
            <i className="fas fa-chevron-right"></i>
          </button>

          <div className="hero-carousel-dots">
            {images.map((_, i) => (
              <button
                type="button"
                key={i}
                className={`hero-carousel-dot ${i === index ? 'active' : ''}`}
                onClick={() => goTo(i)}
                aria-label={`Aller à l'image ${i + 1}`}
              ></button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default HeroCarousel;
